import React from 'react';
import { P2GIcon } from '@parcel2go/core-ui';

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  palette?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  component?: 'div' | 'span';
  onClick?: (event: React.MouseEvent<HTMLElement>) => Promise<void> | void;
  dataTestId?: string;
  children?: React.ReactNode;
  src?: string;
  classNames?: string[] | string;
  id?: string;
}

// Temp Component to wrap P2GCdnIcon for easier future changes. The plan will be to swap to contentful CDN icons later.
const CdnIconProxy = ({ children, size, palette, classNames, id, onClick, dataTestId, component }: Props) => {
  return (
    <P2GIcon
      size={size}
      palette={palette}
      classNames={classNames}
      component={component}
      id={id}
      onClick={onClick}
      dataTestId={dataTestId}
    >
      {children}
    </P2GIcon>
  );
};

export default CdnIconProxy;
